import { ApplicationStatus, ApplicationStep, isApplicationStep } from '@mkp/application/models';
import { mapAuditDates } from '@mkp/shared/data-access';
import { ApplicationStatusDto } from './application-status.dto';

export const mapApplicationStatusDtoToModel = (dto: ApplicationStatusDto): ApplicationStatus => ({
  ...dto,
  ...mapAuditDates(dto),
  step: mapStepToApplicationStep(dto.step),
});
export const mapStepToApplicationStep = (step: number): ApplicationStep => {
  try {
    if (isApplicationStep(step)) {
      return step;
    } else {
      throw new Error(`Error mapping step to ApplicationStep`);
    }
  } catch (error) {
    console.error(error);
    return ApplicationStep.New;
  }
};
